var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('TransactionListTemplate',{ref:"transactionList",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'crop-tracker-list',"setLoading":_vm.setLoading,"loadDataGrid":_vm.loaded}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }